module.exports = __webpack_public_path__ + "static/media/norrieCanoe.6e58fc51.jpg";